import { Flex, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import TicketFormContainer from './TicketForm/TicketFormContainer';
import { useTicketingStore } from '@/stores';

interface NewTicketModalProps {
  isOpen: boolean;
}

export const NewTicketModal = ({ isOpen }: NewTicketModalProps) => {
  const { t, i18n } = useTranslation();
  const { ticketFormData, closeModal } = useTicketingStore();

  return (
    <Modal
      destroyOnClose
      className='sd-font'
      title={
        <div className='text-base font-semibold text-sd-foreground'>
          {ticketFormData && ticketFormData.id
            ? t('edit_ticket')
            : ticketFormData?.external_id
              ? t('new_ticket_for', { platformCode: ticketFormData?.external_id })
              : t('new_ticket')}
        </div>
      }
      width={640}
      centered
      open={isOpen}
      onClose={closeModal}
      onCancel={closeModal}
      footer={null}
      styles={{
        content: { borderRadius: '16px', padding: '24px' },
        header: { borderBottom: '1px solid rgb(232,230,227)', paddingBottom: '16px', marginBottom: '16px' },
        mask: { backgroundColor: 'rgba(0,0,0,0.5)' },
      }}
    >
      <TicketFormContainer />
    </Modal>
  );
};
